export default __webpack_public_path__ + "static/media/Ek.abe54316.jpg";